import React from 'react';
import { Link } from 'react-router-dom';
import { Book } from '../../types';
import { getImagePaths, getBestImagePath, shouldUseThumbnail } from '../../utils/imageUtils';
import Book3D from './Book3D';
import './BookShelf.css';

interface BookShelfProps {
    books: Book[];
    /* The shelf sits in a narrow sidebar on the collage page and in a
       full-width column on a diary entry, so the book's dimensions are
       driven by CSS custom properties rather than fixed pixel sizes. */
    size?: 'small' | 'medium';
    className?: string;
}

const BookShelf: React.FC<BookShelfProps> = ({ books, size = 'medium', className }) => {
    return (
        <ul className={`book-shelf book-shelf--${size} ${className || ''}`.trim()}>
            {books.map(book => {
                const cover = getBestImagePath(
                    getImagePaths(book.coverImage || ''),
                    shouldUseThumbnail('grid')
                );

                return (
                    <li key={book.id} className="book-shelf__item">
                        <Link to={`/books/${book.id}`} className="book-shelf__link">
                            <Book3D cover={cover} title={book.title} />

                            <div className="book-shelf__meta">
                                <span className="book-shelf__title">{book.title}</span>
                                <span className="book-shelf__author">{book.author}</span>
                                <span className="book-shelf__year">{book.publishYear}</span>
                            </div>
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default BookShelf;
